import { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import useFilter from "../../../../../hook/useFilter"
import useVariable from "../../../../../hook/useVariable"
import { fileActions } from "../../../../../store/files-slice"
import Pagination from "./pagination"
import InfoIcon from "../../../../InfoIcon"
import { faFileUpload, faUpload } from "@fortawesome/free-solid-svg-icons"


const Filter = (props) => {

    let defaultfilecount = useSelector((state) => state.file.filterfileCount)
    let pagination = useSelector((state) => state.file.pagination)

    let sliceFilters = useSelector(state => state.file.filter)
    let sliceActions = fileActions
    let sliceItems = useSelector(state => state.file.files)
    const [isMount, setIsMount] = useState(false)

    const { children } = props


    let dispatch = useDispatch()

    const { doFilter } = useFilter()
    const { variableValue } = useVariable()

    const [paginationItems, setPaginationItems] = useState([])

    useEffect(() => {
        let items = []
        if (pagination) {
            pagination.map((item, key) => {

                items.push(<Pagination key={key} files={item} index={key} />)
            })
        }

        setPaginationItems(items)
    }, [pagination])



    useEffect(() => {

        if (!isMount) {
            setIsMount(true)
            return
        }

        doFilter(sliceFilters, sliceItems, sliceActions)


    }, [sliceFilters])


    return <div className="p-3" >
        <div style={{ display: 'flex', justifyContent: 'space-between' }} >
            <div>
                <label>Pagination</label> <select name="filter-pagination" defaultValue={sliceFilters.pagination} className="mb-2" onChange={(event) => {
                    let value = variableValue(event.target.value)

                    dispatch(fileActions.setFilter({
                        key: 'pagination',
                        value
                    }))



                }} >
                    <option value='' >All</option>

                    {
                        defaultfilecount.map((item, key) => {

                            return <option key={key} value={item} >{item}</option>
                        })
                    }
                </select>

                <input type="text" name="filter-filename-filetype-identifier" className="mb-2" defaultValue={sliceFilters.search} placeholder="filename, filetype or identifier" onInput={(event) => {
                    let value = variableValue(event.target.value)


                    dispatch(fileActions.setFilter({
                        key: 'search',
                        value
                    }))


                }} />
            </div>

            <div>

                <button className="btn btn-outline-secondary" type="button" ><InfoIcon icon={faFileUpload} />Upload File</button>
            </div>


        </div>

        {children}
        <div className="pagination-container">{paginationItems}</div>

    </div>
}


export default Filter